import { Box, useTheme } from "@mui/material";
import { IconButtonAnimate } from "../animate";
import SearchDoc from "./SearchDoc";
import useSessionStorage from "@/hooks/useSessionStorage";

export default function ShowSearchBtn() {
  const theme = useTheme();
  const [showSearch, setShowSearch] = useSessionStorage("showSearch", false);
  return (
    <Box mr={2}>
      {showSearch && (
        <SearchDoc setShowSearch={(v: boolean) => setShowSearch(v)} />
      )}

      <IconButtonAnimate
        color={"default"}
        onClick={() => {
          setShowSearch(true);
          // window.open(baseUrl);
        }}
        sx={{
          width: 40,
          height: 40,
          svg: {
            width: 24,
            height: 24,
          },
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M17.1875 17.1765L20 20M18.3333 10.6928C18.3333 14.3891 15.3486 17.3856 11.6667 17.3856C7.98477 17.3856 5 14.3891 5 10.6928C5 6.99647 7.98477 4 11.6667 4C15.3486 4 18.3333 6.99647 18.3333 10.6928Z"
            stroke={theme.palette.text.secondary}
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </IconButtonAnimate>
    </Box>
  );
}
